import { FC, ReactNode, useEffect } from 'react'

import { useAuthStore } from 'shared/store'

import { getNewAccessToken } from '@utils/axios/axiosQueries/auth.requests'
import createSocket from '@utils/createSocket'
import { SocketAuthPatterns } from 'shared/types/sokets.type'

interface IAuthSocketWrapper {
  children: ReactNode
}

const AuthSocketWrapper: FC<IAuthSocketWrapper> = ({ children }: IAuthSocketWrapper) => {
  const { user } = useAuthStore((state) => state)

  const refreshToken = async () => {
    console.log(`refreshing token by socket! at ${Date.now()}`)
    const data = await getNewAccessToken()
  }

  useEffect(() => {
    if (!user) return

    const socket = createSocket('/sockets-auth/', user._id)

    socket.on('connect', () => {
      console.log('auth sockets connected')
    })

    socket.on(SocketAuthPatterns.REFRESH, async () => {
      refreshToken()
    })

    return () => {
      console.log('auth sockets disconnectng')
      socket.disconnect()
    }
  }, [user])

  return <>{children}</>
}

export default AuthSocketWrapper
